<script setup lang="ts">
import AuSkeletonWrapper from '~/components/ui/AuSkeletonWrapper.vue'
import AuSkeleton from '~/components/ui/AuSkeleton.vue'

const { taskCount = 5 } = defineProps<{
  taskCount?: number
}>()
</script>

<template>
  <AuSkeletonWrapper>
    <div class="border-green-40 flex w-full items-stretch overflow-hidden rounded-lg border bg-white">
      <div class="grid flex-1 grid-cols-1 items-start gap-2 p-2.5 md:grid-cols-3 md:gap-4">
        <div class="flex h-full min-w-0 flex-col justify-between">
          <div class="min-h-5">
            <AuSkeleton height="1.25rem" width="70%" />
          </div>
          <div class="mt-1">
            <AuSkeleton height="1rem" width="85%" />
          </div>
        </div>

        <div class="text-left md:text-center">
          <AuSkeleton height="1.25rem" width="6rem" />
        </div>

        <div class="w-full md:w-auto">
          <div class="w-full md:ml-auto md:w-[356px]">
            <div class="mb-1 text-left">
              <AuSkeleton height="1.25rem" width="4rem" />
            </div>
            <div class="flex flex-wrap gap-1">
              <AuSkeleton
                v-for="index in taskCount"
                :key="index"
                height="2rem"
                width="2rem"
                border-radius="50%"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="border-green-40 flex w-8 items-center justify-center border-l">
        <AuSkeleton height="1rem" width="0.5rem" />
      </div>
    </div>
  </AuSkeletonWrapper>
</template>
